// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1ONrC","vLegacy":"SelectSecondary_vLegacy__3lglE","error":"SelectSecondary_error__3U4Pu","disabled":"SelectSecondary_disabled__2swte"};